<div class="content">
  <div class="layout-wrapper">
    <div class="page-header">
      <app-global-header
        [label]="headerCtaLabel"
        [route]="headerCtaRoute"
        [trackingScreenName]="trackingScreenName"
        [trackingObject]="trackingObject"
      >
      </app-global-header>
    </div>

    <div class="page-content">
      <h1 class="form-title" e2eId="form-title">
        {{ title }}
      </h1>

      <h2
        *ngIf="subtitle"
        [class.form-subtitle-with-banner]="errorMessage"
        class="form-sub-title"
        e2eId="form-sub-title"
      >
        {{ subtitle }}
      </h2>

      <app-form-banner
        [message]="errorMessage"
        bannerStyle="error"
      ></app-form-banner>

      <div class="form-body">
        <ng-content></ng-content>

        <div class="social-login">
          <p class="continue-with" e2eId="continue-with">
            {{ 'LABEL.CONTINUE_WITH' | translate }}
          </p>

          <app-oauth-google-circle
            class="oauth-google"
            [trackingObject]="trackingObject"
            [trackingAction]="googleTrackingAction"
            (authenticationSuccess)="googleLoginSuccess.emit($event)"
            (authenticationError)="googleLoginError.emit($event)"
          >
          </app-oauth-google-circle>

          <app-oauth-facebook-circle
            class="oauth-facebook"
            [trackingObject]="trackingObject"
            [trackingAction]="facebookTrackingAction"
            (authenticationSuccess)="facebookLoginSuccess.emit($event)"
            (authenticationError)="facebookLoginError.emit($event)"
          >
          </app-oauth-facebook-circle>

          <app-oauth-apple-circle
            class="oauth-apple"
            [trackingObject]="trackingObject"
            [trackingAction]="appleTrackingAction"
            (authenticationSuccess)="appleLoginSuccess.emit($event)"
            (authenticationError)="appleLoginError.emit($event)"
          >
          </app-oauth-apple-circle>
        </div>
      </div>
    </div>
  </div>

  <div class="customer-review-wrapper">
    <div class="customer-review">
      <p class="review">
        &ldquo;{{ 'CUSTOMER_REVIEW.MESSAGE' | translate }}&rdquo;
      </p>
      <p class="customer-name">
        {{ 'CUSTOMER_REVIEW.NAME' | translate }}
      </p>
      <div class="ratings">
        <i2g-icon class="rating" [icon]="starIcon"></i2g-icon>
        <i2g-icon class="rating" [icon]="starIcon"></i2g-icon>
        <i2g-icon class="rating" [icon]="starIcon"></i2g-icon>
        <i2g-icon class="rating" [icon]="starIcon"></i2g-icon>
        <i2g-icon class="rating" [icon]="starIcon"></i2g-icon>
      </div>
    </div>
  </div>
</div>
